<template>
    <div>
        <div class="container-fluid picking-list" v-cloak>
            <legend>タスクメニューマスタ</legend>

            <!-- 新規追加ボタン -->
            <div class="text-end">
                <button type="button" class="btn btn-outline-info mb-3" @click="edit()">
                    <TablerIcon name="IconPlus" :size="18" />
                    新規作成
                </button>
            </div>

            <div class="container">
                <transition mode="out-in">
                    <draggable @end="onEnd($event)" item-key="no" tag="div" :list="task_menus">
                        <template #item="{ element }">
                            <div class="card my-3" :key="element && element.no" :class="{ 'deleted': element.deleted_at }">
                                <div class="card-body">
                                    <div class="d-flex justify-content-between">
                                        <div class="d-flex justify-content-start align-items-center">
                                            <button class="btn btn-outline-secondary btn-sm me-3" @click="edit(element.id)">
                                                <TablerIcon name="IconEdit" :size="18" />
                                                編集
                                            </button>
                                            <h3 class="card-title mb-0">
                                                {{ element.menu_name }}
                                            </h3>
                                        </div>
                                        <div>
                                            <button class="btn btn-warning btn-sm" @click="toggle(element)" v-if="!element.deleted_at">
                                                <TablerIcon name="IconTrash" :size="18" />
                                                削除
                                            </button>
                                            <button class="btn btn-outline-success btn-sm" @click="toggle(element)" v-else>
                                                <TablerIcon name="IconRotateClockwise" :size="18" />
                                                復元
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </draggable>
                </transition>
            </div>

            <task-menus-editor
                id="task-menus-editor"
                :task_menu_id="task_menu_id"
                @save="reload()"
                @mounted="modalMounted($event)"
                @close="closeModal($event)">
            </task-menus-editor>
        </div>
    </div>
</template>

<script>
    import taskMenusEditor from './taskMenusEditor.vue';
    import draggable from 'vuedraggable';

    export default {
        components: {
            taskMenusEditor,
             draggable,
        },
        data: () => ({
            task_menu_id: null,
            isloading: false,
            task_menus: [],
            modals: [],
        }),

        methods: {
            reload() {
                this.isLoading = true;
                axios.get("/master/task_menus/lists").then(res => {
                    this.task_menus = res.data;
                }).catch(err => {
                    Alert.err(err.response);
                }).finally(() => this.isLoading = false);
            },
            edit(id = null) {
                this.task_menu_id = id;
                setTimeout(() => {
                    this.modals["task-menus-editor"].show();
                });
            },
            toggle(v) {
                // 初期値に復帰情報を設定
                let action = "復帰";
                let type = "info";
                let mode = false;
                // 削除の場合、削除情報に変更して表示
                if (!v.deleted_at) {
                    action = "削除";
                    type   = "warning";
                    mode = true
                }
                swal ({
                    title: `タスクメニューマスタ${action}`,
                    text: `指定のレコードを${action}します。\nよろしいですか？`,
                    icon: type,
                    buttons: ["キャンセル" , action],
                    dangerMode: mode,
                })
                .then((willDelete) => {
                    if (willDelete) {
                        axios.post("/master/task_menus/toggle", {id: v.id}).then(res => {
                            this.reload();
                            Alert.msg(res.data);
                        }).catch(err => {
                            Alert.err(err.response);
                        });
                    }
                });
            },
            onEnd() {
                // order_number書き換え
                this.task_menus.map(function(task, length) {
                    task.order_number = length + 1;
                    return {task}
                });
                this.isLoading = true;
                axios.post("/master/task_menus/dragsort", {task_menus: this.task_menus}).then(res => {
                    this.reload();
                }).catch(err => {
                    Alert.err(err.response);
                }).finally(() => this.isLoading = false);
            },
            modalMounted(id) {
                this.modals[id] = new bootstrap.Modal(document.getElementById(id));
            },
            closeModal() {
                this.reload();
            },
        },
        mounted() {
            this.reload();
        }
    }
</script>